import React, { FC } from 'react';
import BottomSlider from '../../components/BottomSlider/BottomSlider';
import ProjectInfo from '../../pages/projects/components/ProjectInfo/ProjectInfo';

import styles from './projectInfoSlider.module.scss';

type ProjectInfoSliderPropTypes = {
    showBottomSlider: boolean;
    toggleShow: () => void;
    data: any;
}

const ProjectInfoSlider: FC<ProjectInfoSliderPropTypes> = (props) => {
    const { showBottomSlider, toggleShow, data } = props;

    return (
        <BottomSlider visible={showBottomSlider} onClose={toggleShow} title='Info'>
            <div className={styles.projectInfoSliderWrapper}>
                <ProjectInfo item={data} isProjectView showMore />
            </div>
        </BottomSlider>
    );
};

export default ProjectInfoSlider;